__turbopack_context__.v({
  "container": "OtherProductsSection-module__FW-ulW__container",
  "productActions": "OtherProductsSection-module__FW-ulW__productActions",
  "productContent": "OtherProductsSection-module__FW-ulW__productContent",
  "productDescription": "OtherProductsSection-module__FW-ulW__productDescription",
  "productItem": "OtherProductsSection-module__FW-ulW__productItem",
  "productTitle": "OtherProductsSection-module__FW-ulW__productTitle",
  "root": "OtherProductsSection-module__FW-ulW__root",
});
